export default __webpack_public_path__ + "static/media/avatar_15.ffc18609.svg";